import { ContentPageBlocks } from "@/components/content-page-blocks";
import type { ContentBlock } from "@/lib/storefront-types";

type MenuPageCanvasProps = {
  children: React.ReactNode;
  blocks?: ContentBlock[];
  outerClassName?: string;
  innerClassName?: string;
  topSection?: React.ReactNode;
};

export function MenuPageCanvas({
  children,
  blocks = [],
  outerClassName = "",
  innerClassName = "mx-auto max-w-6xl px-4 py-6 sm:px-6 sm:py-8 lg:py-10",
  topSection,
}: MenuPageCanvasProps) {
  return (
    <div
      className={outerClassName}
      style={{ backgroundColor: "var(--storefront-breadcrumb-background)" }}
    >
      {topSection}
      <div className={innerClassName}>{children}</div>
      {blocks.length > 0 ? <ContentPageBlocks blocks={blocks} /> : null}
    </div>
  );
}
